<template>
  <v-col cols="12">
    <v-card>
      <v-card :color="tealColor">
        <v-card-title
          class="font-weight-medium pl-4 pr-4 pt-2 pb-2 white--text"
        >
          {{ interviews.Title }}
        </v-card-title>
      </v-card>
      <v-divider/>
      <v-card-text class="text--primary pb-0">
        {{ interviews.Description }}
        <p class="font-weight-bold title">
          {{ interviews.InterviewDate }}
        </p>
      </v-card-text>

      <v-card-text
        v-if="interviews.teacher!=''"
        class="pt-0 pb-0 mt-0">
        <p >
          <v-icon
            small
            :color="tealColor">person</v-icon>
          {{ interviews.teacher }}
        </p>
      </v-card-text>

      <v-card-text
        v-if="interviews.Location!=''"
        class="pt-0 pb-0 mt-0">
        <p >
          <v-icon
            small
            :color="tealColor">mdi-map-marker</v-icon>
          {{ interviews.Location }}
        </p>
      </v-card-text>

      <v-card-text
        v-if="messageSend === (interviews.id).toString()"
        class="pt-0 pb-0 mt-0">
        <v-alert
          type="warning"
          prominent
        >{{ messageToShow }}
        </v-alert>
      </v-card-text>

      <div class="pl-4 pr-4 pt-0">
        <v-select
          outlined
          label='Select time'
          v-model="selectedTime"
          :items='interviews.SessionTimes'
          item-value="id"
          item-text='timeSlot'
          color="teal"
          :rules="selectRules">
          <template v-slot:item="{ on, item }">
            <v-list-item
              v-on="on"
              :disabled="item.disabled">{{ item.timeSlot }}
              <v-spacer/>
              <v-chip
                text-color="white"
                :color="item.color"
                small
              >{{ item.status }}</v-chip>
            </v-list-item>
          </template>
        </v-select>
        <v-textarea
          outlined
          v-if="interviews.WithComment && selectedTime!=''"
          clearable
          clear-icon="mdi-close-circle"
          :label="interviews.boxLabel"
          v-model="parentsNote"
          rows="3"
          row-height="25"
          auto-grow
          color="teal"
        />

      </div>

      <v-card-text
        class="text--primary pl-4 pr-4 pt-0 pb-2"
        v-if="selectedTime!=''">

        <div><span class="font-weight-medium">Name: </span>{{ caregiverName }}</div>
        <div><span class="font-weight-medium">Email Address: </span>{{ caregiverEmail }}</div>
        <div><span class="font-weight-medium">Student Name: </span>{{ pupilName }}</div>

      </v-card-text>

      <v-row v-if="alertMsg!=''">
        <v-col class="pa-2 ma-2">
          <v-alert
            :color="alertColor"
            :value="alert"
            class="white--text"
          >
            {{ alertMsg }}
          </v-alert>
        </v-col>

      </v-row>
      <v-card-actions v-if="selectedTime!=''">
        <v-spacer/>
        <v-btn
          outlined
          color="teal"
          :disabled="selectedTime == ''"
          @click.stop="bookTime(interviews.id)">
          Book Interview
        </v-btn>
      </v-card-actions>

      <v-divider/>

      <v-card-subtitle class="red--text">
        <b> Closing on: </b>{{ interviews.Deadline }}
      </v-card-subtitle>

    </v-card>
  </v-col>

</template>

<script>
import { mapState } from 'vuex'

export default {
  props: {
    interviews: {
      type: Object,
      default: () => { return {} }
    },
    caregiverEmail: {
      type: String,
      default: ''
    },
    caregiverName: {
      type: String,
      default: ''
    },
    pupilName: {
      type: String,
      default: ''
    },
    messageSend: {
      type: String,
      default: ''
    }
  },

  components: {

  },

  data: function () {
    return {
      tealColor: '#00B0B9',
      selectedTime: '',
      alertMsg: '',
      alertColor: '',
      messageToShow: 'The interview has already been scheduled by the other caregiver.',
      parentsNote: '',
      selectRules: [
        v => !!v || 'This field is required'
      ]
    }
  },

  computed: {
    ...mapState(['Dbasename', 'schoolId', 'status', 'teacherId', 'teacherName', 'loadingDialog', 'withPinSetup']),
    alert: function () {
      if (this.alertMsg !== '') {
        return true
      } else {
        return false
      }
    }
  },

  methods: {

    bookTime: function (bookingId) {
      this.$store.commit('loading', true)

      this.$http.post('pupilsV2/' + this.$store.state.Dbasename + '/' + this.$store.state.pupilId + '/' + this.$store.state.trueUser + '/bookInterviewV2', {
        bookingId: bookingId,
        timeSlot: this.selectedTime,
        parentsNote: this.parentsNote
      }).then(resp => {
        console.log(resp.data)

        if (resp.status === 200) {
          this.alertColor = 'success'
          this.alertMsg = 'Booked Successfully'
          this.selectedTime = ''
          this.parentsNote = ''
          this.$emit('get-interviews')

          this.$store.commit('loading', false)
        } else {
          this.alertColor = 'error'
          this.alertMsg = resp.data.message

          this.$store.commit('loading', false)
        }
      })
    }
  }
}
</script>
